<template>
    <div class="bg-light" :style="`min-height: 700px;`">
        <div ref="observerBlog"></div>

        <!-- Container de Busca quando tiver título, no caso de página do Blog -->
        <div class="container" v-if="data.titulo == ''">
            <div class="col-12 pb-4 pb-xl-0">
                <div class="font-glacial-regular row d-box align-items-center text-center">
                    <b-form-input class="form-search font-45 search-padding" size="lg" v-model="text1" @input="searchDebounce" type="text" placeholder="  buscar">
                    </b-form-input>
                </div>
            </div>
        </div>

        <transition-group enter-active-class="animated fadeInUp">
            <div class="container" key="categorias">
                <div class="row mt-5 pt-4 pb-4" v-if="$route.params.autor && autor">
                    <div class="col-xl-3 col-12 d-flex justify-content-center align-items-center">
                        <div class="rounded-photo background-image" :style="'background-image: url('+authorAvatar(autor)+');'"></div>
                    </div>
                    <div class="col-xl-6 col-12">
                        <p class="font-glacial-bold font-56 margin-0 text-xl-left text-center">{{autor.name}}</p>
                        <p class="font-glacial-bold text-uppercase font-11 text-categories-red text-xl-left text-center">
                            <b-img src="/wp-content/themes/rhiza/src/assets/line2.png"></b-img>
                            Autor
                        </p>
                        <p class="font-glacial-regular font-20 font-italic text-xl-left text-center">{{autor.description}}</p>
                    </div>
                </div>

                <div class="row justify-content-center pt-4 pt-xl-0">

                    <div class="d-flex justify-content-center align-items-center mt-md-5 mb-md-5">
                        <div :class="{'pr-md-5 mr-xl-5': $route.path != '/'}" v-if="data.titulo != ''">
                            <h2 class="font-glacial-bold text-center font-70">
                                {{data.titulo}}
                            </h2>
                        </div>
                        <div class="blog-categories" v-if="$route.path != '/'">
                            <div>
                                <a href="javascript:void(0)" class="font-glacial-bold font-15 font-size-blog d-block d-xl-block text-center px-3 my-2" 
                                    @click="changeCategory(2)"
                                    :class="{'text-categories-red' : selected == 2}">
                                    GERAL
                                </a>
                            </div>
                            <div v-for="(d, index) in categories" :key="index">
                                <b-link href="javascript:void(0)" class="font-glacial-bold font-15 font-size-blog text-uppercase d-block d-xl-block  px-3 my-2btn-pointer text-center" 
                                    @click="changeCategory(d.id)" 
                                    :class="{'text-categories-red' : selected == d.id}">
                                    {{d.name}}
                                </b-link>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row eventos btn-pointer justify-content-center pt-5 pt-sm-0" v-if="data.titulo == '' ">
                    <blog-item type="post" no-grid :item="d" :large="index == 0 || index == 3" v-for="(d, index) in postsSliced" :key="index" />              
                </div>
            </div>

            <div key="blog" v-if="showObserver && data.titulo != '' && posts.length">
                <div class="container-fluid relacionados d-block">
                    <div class="row justify-content-center pt-4 pb-3 pt-xl-0 pb-xl-0">
                        <div class="col-xl-12 col-10 mb-4 mb-md-0">
                            <slick class="eventos" :options="slickOptions" v-if="posts">
                                <blog-item 
                                    type="post" 
                                    class="text-white pr-1" 
                                    :item="d" 
                                    :large="index == 0 || index == 3" 
                                    v-for="(d, index) in posts" 
                                    :key="index"
                                />
                            </slick>
                        </div>
                    </div>
                </div>
                <div class="text-center pb-5" v-if="!loading && $route.name == 'Home'">
                    <b-button variant="ver-todos" class="col-12 col-xl-2 mb-1 mt-0 btn-opacidade" to="/blog"></b-button>
                </div>
            </div>


            <div class="container d-flex justify-content-center" key="msg">
                <div class="font-glacial-regular font-30 pt-4 pb-3 pt-5 pb-5 mb-4 mt-4 mt-md-0 mt-lg-0 mt-xl-0 text-gray-light text-center" v-if="!loading && posts.length == 0">
                    Esta categoria ainda não possui conteúdo
                </div>
            </div>
        </transition-group>

        <div v-if="$route.name == 'blog'">
            <div class="col-12 text-categories-red text-center font-glacial-bold font-20" v-if="loading">
                <rotate-square2 class="box-center"></rotate-square2>
            </div>
            <div id="load-post"></div>
        </div>
    </div>

</template>
<script>
import observer from 'intersection-observer';
import { RotateSquare2 } from 'vue-loading-spinner'

export default {
    components: {
        RotateSquare2
    },
    props:{
        data: null,
    },
    data(){
        return{
            posts: [],
            autor: null,
            categories: null,
            showObserver: false,

            total: 0,
            scrollPercentage: 0,
            page: 0,
            pageLength: 7,
            text1: '',

            visible: false,
            show: false,

            selected: 2,

            loading: false,
            newPage: true,
            
            slickOptions: {
                arrows: true,
                slidesToShow: 5,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ]

                // Any other options that can be got from plugin documentation
            },
        }
    },
    created() {
        this.load()
    },

    mounted() {
        var observer = new IntersectionObserver((entries) => {
            // If intersectionRatio is 0, the target is out of view
            // and we do not need to do anything.
            if (entries[0].intersectionRatio <= 0) {
                return;
            }
            this.showObserver = true
            
            observer.unobserve(this.$refs.observerBlog)
        });
        observer.POLL_INTERVAL = 100;
        observer.observe(this.$refs.observerBlog)

        if (this.$route.name == 'blog') {
            window.addEventListener("scroll", this.scrollEvent)
        }
    },

    beforeDestroy() {
        window.removeEventListener("scroll", this.scrollEvent)
    },

    methods:{
        scrollEvent(e) {
            var el = document.getElementById('load-post')
            
            if (!el) {
                return
            }

            if (this.isInViewport(el)) {
                this.loadMore()
            }
        },

        isInViewport(elem) {
            var bounding = elem.getBoundingClientRect();
            return (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        },

        authorAvatar(d){
            if(d.mpp_avatar && d.mpp_avatar.full){
                return d.mpp_avatar.full
            } else {
                return '/wp-content/themes/rhiza/dist/assets/blank-profile-picture.png'
            }
        },

        removeAcento(text){
            text = text.replace(new RegExp('[ÁÀÂÃ]','gi'), 'a');
            text = text.replace(new RegExp('[ÉÈÊ]','gi'), 'e');
            text = text.replace(new RegExp('[ÍÌÎ]','gi'), 'i');
            text = text.replace(new RegExp('[ÓÒÔÕ]','gi'), 'o');
            text = text.replace(new RegExp('[ÚÙÛ]','gi'), 'u');
            text = text.replace(new RegExp('[Ç]','gi'), 'c');
            text = text.replace(' ', '-');
            
            return text.toLowerCase();	
        },

        searchDebounce: _.debounce(function() {
            this.page = 0
            this.posts = []
            this.newPage = true
            this.loadMore()
        }, 200),

        changeCategory(cat) {
            this.selected = cat
            this.page = 0
            this.posts = []
            this.newPage = true
            this.category = cat

            this.loadMore()
        },

        async loadMore(){
            if (!this.newPage) {
                return
            }

            if (this.loading) {
                return
            }

            this.page++

            this.loading = true

            var url = window.SETTINGS.API_BASE_PATH + `posts?_embed&per_page=${this.pageLength}&page=${this.page}&categories=2`
            if (this.category > 0) {
                url += `&categories=${this.category}`
            }

            if(this.text1 != ""){
                url +=`&search=${this.text1}`
            }

            if(this.$route.params.autor){
                var urlUser = window.SETTINGS.API_BASE_PATH + "users?_embed"
                var response = await axios.get(urlUser)

                for (let i = 0; i < response.data.length; i++) {
                    if (this.removeAcento(response.data[i].name) == this.$route.params.autor) {
                        this.autor = response.data[i]
                    }
                }

                if (this.autor) {
                    var arrTitle = document.title.split('|');
                    var [baseTitle] = arrTitle.slice(-1);
                    
                    var d = document.createElement('div');
                    d.innerHTML =  `${this.autor.name} | ${baseTitle}`
                    document.title = d.innerText
                }
                
                url += `&author=${this.autor.id}`
            }

            try {
                var response = await axios.get(url)
                
                if (response.data.length < this.pageLength) {
                    this.newPage = false
                }

                this.total = response.headers["x-wp-total"]
                this.postsSliced = response.data
            } catch (e) {
                this.newPage = false
                console.log(e)
            }

            this.loading = false
        },

        async loadImg(url){
            let img = new Image();
            img.src = url
        },

        async load(){
            this.loadMore()

            var url = window.SETTINGS.API_BASE_PATH + "categories?_embed&parent=2"

            var response = await axios.get(url)
            this.categories = response.data
        },
    },

    computed:{
        postsSliced: {
            set(value) {
                var arr = this.posts.concat(value)
                this.posts = arr
            },

            get() {
                if (!this.posts) {
                    return []
                }

                return this.posts
            }
        },
    },

}
</script>
<style scoped>
.box-center {
    margin: 20px auto;
}
.spinner:after {
    background: #FF0002 !important;
}

a,
a:hover {
    color: #212529
}

a.text-categories-red,
a.text-categories-red:hover {
    color: #ff0004;
}

div.blog-categories {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/widgets/slider_blog.vue